import { render } from "./ElectronicFundTransferView.vue?vue&type=template&id=148b1864"
import script from "./ElectronicFundTransferView.vue?vue&type=script&lang=js"
export * from "./ElectronicFundTransferView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__